import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { agentV2Request } from './agent-v2-request'

export async function deleteAgentV2Conversation(conversationId: string): Promise<void> {
  return agentV2Request({
    url: `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${conversationId}`,
    method: 'DELETE',
    sentryEndpoint: 'DELETE /api/v2/agent/conversations/{conversation_id}',
    expectedErrorStatuses: [404],
    allowNoContent: true,
    parseResponse: () => undefined,
  })
}
